export enum VatRateType {
  Sales = 'sales',
  Purchase = 'purchase',
}
